import './App.css'
import { Switch, Route, Link } from 'react-router-dom'
// import { CSSTransitionGroup } from 'react-transition-group'
import Transition from 'react-transition-group/Transition'
// import { CSSTransition } from 'react-transition-group'

import React, {Component, Fragment} from 'react'

const duration = 500;

const headerDivDefaultStyle = {
  width: '100%',
  // display: 'flex',
  // flexGrow: 1,
  // alignSelf: 'center',
  // transition: `font-size ${duration}ms ease-in-out, transform ${duration} ease-in-out`,
  transition: `${duration}ms ease-in-out`,
  fontSize: '6vh',
  transform: 'translateX(0%)'
}

const headerDivTransitionStyles = {
  exiting: { fontSize: '6vh', transform: 'translateX(0%)' },
  exited:  { fontSize: '2vh', transform: 'translateX(-50%)' },
};

const headerDefaultStyle = {
  position: 'relative',
  left: '0vh',
  transition: `left ${duration}ms ease-in-out`
}

const headerTransitionStyles = {
  exiting: { left: '0vh' },
  exited:  { left: '14vh' }
}

const spacerDefaultStyle = {
  // transition: `flex-grow ${duration} ease-in-out`,
  // flexGrow: 1
  transition: `transform ${duration} ease-in-out`,
  transform: 'translateX(50%)'
}

const spacerTransitionStyles = {
  exiting: { transform: 'translateX(50%)' },
  exited: { transform: 'translateX(0%)' }
}

class Header extends Component {
  render() {
    return (
      <Route
        path="/"
        render={props => (
            <Transition
              in={(props.match.isExact)}
              timeout={0}
            >
              {(state) => (
                <div
                  className="App-heading"
                >
                  <div
                    style={{
                      ...headerDivDefaultStyle,
                      ...headerDivTransitionStyles[state]
                    }}
                  >
                    <Link to="/">
                      <h2
                        style={{
                          ...headerDefaultStyle,
                          ...headerTransitionStyles[state]
                        }}
                      >Brainy.Space</h2>
                    </Link>
                  </div>
                </div>
              )}
            </Transition>
          )}
      />
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/Header.js